import './App.css';
import React, { useState } from 'react';

function App() {
  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      backgroundColor: "#f0f0f0",
      textAlign: "center",
    },
    heading: {
      fontSize: "2.5rem",
      color: "#333",
      marginBottom: "20px",
    },
    counter: {
      fontSize: "2rem",
      color: "#555",
      marginBottom: "20px",
    },
    button: {
      padding: "10px 20px",
      margin: "10px",
      fontSize: "1rem",
      cursor: "pointer",
      backgroundColor: "#008CBA",
      color: "#fff",
      border: "none",
      borderRadius: "5px",
      outline: "none",
      transition: "background-color 0.3s ease",
    },
    buttonRemove: {
      backgroundColor: "#f44336",
    },
    buttonHover: {
      backgroundColor: "#005f6a",
    }
  };

  const [counter, setCounter] = useState(0);

  function addOne() {
    if (counter >= 20) {
      setCounter(20);
    } else {
      setCounter(counter + 1);
    }
    console.log("clicked add", counter);
  }

  function removeOne() {
    if (counter <= 0) {
      setCounter(0);
    } else {
      setCounter(counter - 1);
    }
    console.log("clicked remove", counter);
  }

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Counter Project</h1>
      <h2 style={styles.counter}>Counter: {counter}</h2>
      <button style={styles.button} onClick={addOne}>Add</button>
      <button style={{ ...styles.button, ...styles.buttonRemove }} onClick={removeOne}>Remove</button>
    </div>
  );
}

export default App;

